import React from 'react';
import logo from './img/logo-white.svg';
import is from './img/is.svg'
import screenshot from './img/fe.png'
import './App.css';

function App() {
  return (
    <div className="App">
      <header className="App-header">
      <img src={logo} alt="logo" />
      <img src={is} alt="logo" className='informal-logo pt-4 pb-8'/>
        
        <p>
          Please click link below to go to Babylons BTC Staking App <br></br>then search for <i>Informal Systems.</i>
        </p>
        <a
          className="App-link"
          href="https://btcstaking.babylonlabs.io/"
          target="_blank"
          rel="noopener noreferrer"
        >
        <img src={screenshot} alt="logo" />
        
          <br></br>Babylon BTC Staking App
        </a>
      </header>
    </div>
  );
}

export default App;
